import { isEqual } from 'lodash';
import { behandelingLabels } from '@common/interfaces/somnology/osase/treatmentsFields';
import { FormDivider } from '@frontend/components/elements/common';
import { ProcessItemFooter } from '@frontend/components/pages/episodes/ProcessItemFooter';
import { translateKey } from '@frontend/translate';
import type { ICustomControlRequestReadProps } from '../../../interfaces/customControlRequestReadProps';
import type { IOsaseBehandeling, IOsaseV2RequestCustomControlData } from './OsaseV2RequestAddEdit';
import { getServiceLabel } from '../../../../../../../common/customControls/getServiceLabel';
import { getDisplayName } from '../../../../../../../common/utils/getDisplayName';
import { ContactReadButtons } from '../../../../../elements/carePathButtons/ContactReadButtons';
import { ProcessContainer } from '../../../../episodes/common';
import { ProcessItemHeader } from '../../../../episodes/ProcessItemHeader';
import { CustomControlCollapseBody } from '../../../utils/v1/CustomControlCollapseBody';
import { osaseV2RequestInitializeCustomControlData } from './OsaseV2RequestAddEdit';
import { OsaseV2RequestReadCustomControlFields } from './OsaseV2RequestReadCustomControlFields';
import { OsaseV2RequestSummary } from './OsaseV2RequestSummary';

export function OsaseV2RequestRead(props: ICustomControlRequestReadProps) {
    const customControlData: Omit<IOsaseV2RequestCustomControlData, 'behandelend_arts_id'> =
        props.request.customControlData;

    return (
        <ProcessContainer>
            <ProcessItemHeader
                date={props.process.dateSent || (props.request && props.request.dateSent)}
                isFirstItem={props.isFirstItem}
                isFirstProcess={props.itemState.isFirstProcess}
                isItemOpen={props.itemState.isOpen}
                onToggle={async (isOpened) => {
                    await props.updateItemState({ ...props.itemState, isOpen: isOpened });
                }}
                organizationName={props.process.requesterOrganization?.name}
                practitionerName={
                    props.process.requesterPractitioner
                        ? getDisplayName(props.process.requesterPractitioner)
                        : undefined
                }
                process={props.process}
                serviceType={props.process.serviceType}
                title={getProcessHeaderTitle()}
            />

            {!isEqual(osaseV2RequestInitializeCustomControlData(), customControlData) && (
                <>
                    {(customControlData.anamnese || customControlData.beleid) && (
                        <>
                            <OsaseV2RequestSummary {...customControlData} />
                            <FormDivider />
                        </>
                    )}
                    <CustomControlCollapseBody isOpen={props.itemState.isOpen}>
                        <OsaseV2RequestReadCustomControlFields
                            {...{
                                ...customControlData,
                                requestId: props.request.id,
                            }}
                        />
                    </CustomControlCollapseBody>
                    <ProcessItemFooter
                        isItemOpen={props.itemState.isOpen}
                        labelLess={
                            translateKey('common.showLess')[0].toUpperCase() + translateKey('common.showLess').slice(1)
                        }
                        labelMore={
                            translateKey('common.showMore')[0].toUpperCase() + translateKey('common.showMore').slice(1)
                        }
                        onToggle={async (isOpened) =>
                            await props.updateItemState({ ...props.itemState, isOpen: isOpened })
                        }
                    />{' '}
                </>
            )}

            <ContactReadButtons {...props} />
        </ProcessContainer>
    );

    function getProcessHeaderTitle() {
        const behandelings: string[] = [];
        const behandelingKeys = Object.keys(behandelingLabels).reverse();

        behandelingKeys.forEach((key) => {
            if (customControlData.behandeling[key as keyof IOsaseBehandeling]) {
                if (key === ('pap' as keyof IOsaseBehandeling) && customControlData.pap.type) {
                    behandelings.push(customControlData.pap.type);
                } else {
                    behandelings.push(behandelingLabels[key as keyof IOsaseBehandeling]);
                }
            }
        });

        return `${getServiceLabel(props.process.code, 'request', props.process.name)} ${
            behandelings.length ? ` -  ${behandelings.join(' + ')}` : ''
        }`;
    }
}
